import { z } from "zod/v4";

import { ShippingRateDtoSchema } from "./shipping-rates";

export const RateGroupTypeList = [
  "flatRate",
  "flatRateWithThreshold",
  "thresholdOnly",
  "tieredByPriceOrWeight",
  "custom",
] as const;
export type RateGroupType = (typeof RateGroupTypeList)[number];

export const ShippingRateGroupDtoSchema = z.object({
  groupType: z.enum(RateGroupTypeList),
  position: z.number(), // rendering order
  rates: ShippingRateDtoSchema.array(),
  id: z.uuid(),
  variationId: z.uuid(),
});
export type ShippingRateGroupDto = z.infer<typeof ShippingRateGroupDtoSchema>;

export const CreateShippingRateGroupDtoSchema =
  ShippingRateGroupDtoSchema.extend({
    id: z.uuid().optional(),
  });

export type CreateShippingRateGroupDto = z.infer<
  typeof CreateShippingRateGroupDtoSchema
>;
